import React from "react";
import { Grid, Paper, Typography, LinearProgress } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import { fmt } from "./pnlUtils";

function Card({ title, value, sub, progress, brand }) {
  const theme = useTheme();
  const borderCol = alpha(theme.palette.divider, 0.6);

  return (
    <Paper
      sx={{
        p: 2,
        borderRadius: 2,
        height: "100%",
        border: `1px solid ${borderCol}`,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[1],
      }}
    >
      <Typography
        variant="caption"
        sx={{ opacity: 0.75, fontWeight: 600, display: "block" }}
      >
        {title}
      </Typography>
      <Typography variant="h6" sx={{ fontWeight: 900, lineHeight: 1.2 }}>
        {value}
      </Typography>
      {sub && (
        <Typography variant="caption" sx={{ opacity: 0.7 }}>
          {sub}
        </Typography>
      )}
      {typeof progress === "number" && (
        <LinearProgress
          variant="determinate"
          value={Math.max(0, Math.min(100, progress))}
          sx={{
            mt: 1,
            height: 8,
            borderRadius: 5,
            bgcolor: alpha(theme.palette.text.primary, 0.08),
            "& .MuiLinearProgress-bar": { bgcolor: brand, borderRadius: 5 },
          }}
        />
      )}
    </Paper>
  );
}

export default function SummaryMetrics({
  brand,
  equity,
  usdtBal,
  totalUnrealized,
  totalIM,
  available,
  marginRatio,
}) {
  return (
    <Grid container spacing={1.2} sx={{ mb: 2 }}>
      <Grid item xs={12} sm={6} md={3}>
        <Card
          title="Equity"
          value={`${fmt(equity, 2)} USDT`}
          sub={`Wallet: ${fmt(usdtBal, 2)} • U-PnL: ${fmt(totalUnrealized, 2)}`}
          brand={brand}
        />
      </Grid>
      <Grid item xs={6} md={2.25}>
        <Card
          title="Unrealized PnL"
          value={`${fmt(totalUnrealized, 2)} USDT`}
          brand={brand}
        />
      </Grid>
      <Grid item xs={6} md={2.25}>
        <Card
          title="Initial Margin (Σ)"
          value={`${fmt(totalIM, 2)} USDT`}
          brand={brand}
        />
      </Grid>
      <Grid item xs={6} md={2.25}>
        <Card
          title="Available"
          value={`${fmt(available, 2)} USDT`}
          brand={brand}
        />
      </Grid>
      <Grid item xs={6} md={2.25}>
        <Card
          title="Margin Ratio"
          value={`${fmt(marginRatio * 100, 2)}%`}
          progress={marginRatio * 100}
          brand={brand}
        />
      </Grid>
    </Grid>
  );
}
